import React from "react";

import { SizeClass } from "@/src/common/Utils/SizeClass";
import { WASizePreviewCompact } from "./WASizePreviewCompact";
import { WASizePreviewProps } from "./WASizePreviewProps";
import { WASizePreviewRegular } from "./WASizePreviewRegular";
import { useSizeClass } from "@/src/common/Utils/useSizeClass";

export function WASizePreview(props: WASizePreviewProps) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;

  if (props.fullScreen) {
    return <WASizePreviewRegular {...props} hideHeader />;
  }

  if (isCompact) {
    return <WASizePreviewCompact {...props} />;
  }

  return <WASizePreviewRegular {...props} />;
}
